import { render, staticRenderFns } from "./districtList.vue?vue&type=template&id=e573e59c&scoped=true&"
import script from "./districtList.vue?vue&type=script&lang=js&"
export * from "./districtList.vue?vue&type=script&lang=js&"
import style0 from "./districtList.vue?vue&type=style&index=0&id=e573e59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e573e59c",
  null
  
)

export default component.exports